export enum CampaignStatus {
  Scheduled = 1,
  InProgress = 2,
  Completed = 3,
  Cancel = 4,
}

export enum CampaignSource {
  Rules = 1,
  Report = 2,
  Clients = 3,
}

export enum SmsVendor {
  Bandwidth="Bandwidth",
  SMSIndia="SMSIndia",
  Others="Others",
}

export enum CampaignExecutionType
{
    Campaign = 1,
    Automation = 2,
}




